import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { verifyToken } from "./service/authService";
import Cookies from "js-cookie";
// Cache token verification — no full-page loader
let lastVerifiedTime = 0;
const VERIFY_COOLDOWN = 10 * 60 * 1000; // 10 minutes

const ProtectedRoute = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let token_ = localStorage.getItem("auth_token") || Cookies.get("auth_token");

  // Optimistically show page if token exists (fast feel, verify in background)
  const [auth, setAuth] = useState(!!token_);

  useEffect(() => {
    const checkData = async () => {
      const now = Date.now();
      if (now - lastVerifiedTime < VERIFY_COOLDOWN) {
        setAuth(true);
        return;
      }

      verifyToken()
        .then((res) => {
          if (
            res &&
            (res?.status === 401 ||
              res?.data?.status === 401 ||
              res?.data?.status === 400 ||
              res?.status === 400)
          ) {
            localStorage.removeItem("auth_token");
            Cookies.remove("auth_token");
            setAuth(false);
            navigate("/signin");
          } else {
            lastVerifiedTime = Date.now();
            setAuth(true);
          }
        })
        .catch(() => {
          // Keep optimistic UI on network glitch if token exists
          if (token_) setAuth(true);
        });
    };

    if (!token_) {
      setAuth(false);
      navigate("/signin");
    } else {
      setAuth(true);
      checkData();
    }
  }, [token_, dispatch, navigate]);

  if (!token_) return null;

  return <>{auth && props.children}</>;
};
export default ProtectedRoute;
